import { computedFrom } from "aurelia-framework";
import { LocaleService } from "../../services/locale-service";
import { SelectItem } from "../../components/select-item";

export enum Berechnungsart {
  pumpe_nachrechnen,
  pumpe_auslegen,
}

export enum Anwendung {
  schmieroelAnwendung,
  marinekraftstoffAnwendung,
}

export enum TypViskositaet {
  kinematisch,
  dynamisch,
}

export class Pumpentyp extends SelectItem {}
export class Foerderfluessigkeit extends SelectItem {}
export enum TypFoerderfluessigkeit {
  marinekraftstoff,
  schmieroel,
}

export class ProductfinderData {
  constructor(other?: ProductfinderData) {
    if (other) $.extend(true, this, other);
  }

  berechnungsart: Berechnungsart = Berechnungsart.pumpe_nachrechnen;

  pumpentyp: Pumpentyp;

  geraeuschoptimiert: boolean;

  gewuenschterFoerderstrom: number;
  gewuenschterFoerderstromUnit: string = "liter_per_min";

  betriebsdruck: number;
  betriebsdruckUnit: string = "bar";

  betriebsdrehzahl: number;
  betriebsdrehzahlUnit: string = "rpm";

  netzfrequenz: number = 50;

  // Foerderfluessigkeit
  anwendung: Anwendung = Anwendung.schmieroelAnwendung;
  marinekraftstoff: Foerderfluessigkeit;
  schmieroel: Foerderfluessigkeit;

  // Temperaturen
  betriebstemperatur: number;
  betriebstemperaturUnit: string = "celsius";
  anfahrtemperatur: number;
  anfahrtemperaturUnit: string = "celsius";
  anfahrtemperaturEnabled: boolean;

  // Viskositaet (wenn manuelleViskositaet==true)
  typViskositaet: TypViskositaet = TypViskositaet.kinematisch;
  betriebsviskositaet: number;
  betriebsviskositaetUnit: string = "squaremillimeters_per_second";
  startviskositaet: number;
  startviskositaetUnit: string = "squaremillimeters_per_second";
  startviskositaetEnabled: boolean;
  dichte: number;
  dichteUnit: string = "g_per_cubiccentimeters";

  // Leistung (Ausgabeeinheit)
  leistungUnit: string = "kW";

  @computedFrom("anwendung", "schmieroel", "marinekraftstoff")
  get manuelleViskositaet(): boolean {
    return (
      (this.anwendung == Anwendung.schmieroelAnwendung &&
        this.schmieroel &&
        this.schmieroel.id == "-") ||
      (this.anwendung == Anwendung.marinekraftstoffAnwendung &&
        this.marinekraftstoff &&
        this.marinekraftstoff.id == "-")
    );
  }

  set manuelleViskositaet(m: boolean) {
    // intentionally ignored
  }

  /**
   * Returns a clone of this instance, which can be used to send it to the
   * server. In the cloned instance, all number fields which contain
   * strings at runtime (due to databinding of the input fields) are
   * replaced with float values.
   *
   * @param localeService needed to convert strings to floats, using current
   * locale
   */
  createCopyForServer(localeService: LocaleService): ProductfinderData {
    // clone this, see http://stackoverflow.com/a/122704/1601438
    let clone = $.extend(true, {}, this);
    // all number fields: convert strings to floats
    for (let prop of [
      "gewuenschterFoerderstrom",
      "betriebsdruck",
      "betriebsdrehzahl",
      "betriebstemperatur",
      "anfahrtemperatur",
      "betriebsviskositaet",
      "startviskositaet",
      "dichte",
    ]) {
      if (clone[prop]) {
        clone[prop] = localeService.parseFloat(clone[prop]);
      }
    }
    // set computed property
    clone["manuelleViskositaet"] = this.manuelleViskositaet;
    // cleanup typescript metadata
    delete clone["__metadata__"];
    delete (clone as any)["createCopyForServer"];
    return clone;
  }

  clear() {
    (<any>this).pumpentyp = undefined;
    (<any>this).gewuenschterFoerderstrom = undefined;
    (<any>this).betriebsdruck = undefined;
    (<any>this).betriebsdrehzahl = undefined;
    (<any>this).marinekraftstoff = undefined;
    (<any>this).schmieroel = undefined;
    (<any>this).betriebstemperatur = undefined;
    (<any>this).anfahrtemperatur = undefined;
    (<any>this).anfahrtemperaturEnabled = false;
    (<any>this).betriebsviskositaet = undefined;
    (<any>this).startviskositaet = undefined;
    (<any>this).startviskositaet = undefined;
    (<any>this).dichte = undefined;
  }
}
